import axios from "axios";
import fileDownload from "js-file-download";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const listPL = async (params: any) => {
  const { data: response } = await axios.get(endpoints.PL, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const getSummaryBranch = async (params: any) => {
  const { data: response } = await axios.get(endpoints.PL_SUMMARY_BRANCH, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const getSummaryRegion = async (params: any) => {
  const { data: response } = await axios.get(endpoints.PL_SUMMARY_REGION, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const getCOA = async () => {
  const { data: response } = await axios.get(endpoints.PL_COA, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const getPL = async (id: number | string) => {
  const { data: response } = await axios.get(endpoints.DETAIL_PL(Number(id)), {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createPL = async (params: any) => {
  const { data: response } = await axios.post(endpoints.PL, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updatePL = async (id: number | string, params: any) => {
  const { data: response } = await axios.patch(endpoints.DETAIL_PL(Number(id)), params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const downloadTemplate = async () => {
  await axios
    .get(endpoints.PL_DOWNLOAD_TEMPLATE, {
      headers: {
        Authorization: accessToken,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "arraybuffer",
    })
    .then((res) => {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileDownload(blob, "pl_template.xlsx");
    });
};

const uploadBulkTemplate = async (params: FormData) => {
  const { data: response } = await axios.post(endpoints.UPLOAD, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const plService = {
  listPL,
  getSummaryBranch,
  getSummaryRegion,
  getCOA,
  getPL,
  createPL,
  updatePL,
  downloadTemplate,
  uploadBulkTemplate,
};

export default plService;
